<template>
  <b-modal dialog-class="modal-xl"
           :title="helper.trans('labels.crossBorderRates')"
           :modelValue="modal"
           footer-class="d-flex justify-content-between"
           @update:modelValue="modal = $event"
  >
    <template #default>
      <div style="min-height: 460px">
        <div v-for="error in generalErrors" :key="error.message" class="alert alert-danger mt-2 mb-0">
          {{ error.message }}
        </div>

        <div class="mt-3">
          <table class="table align-middle" style="table-layout: fixed">
            <thead>
            <tr class="bg-light">
              <th class="text-capitalize-first" style="width: 12%">{{ helper.trans('labels.crossBorderCurrency') }}</th>
              <th class="text-capitalize-first" style="width: 18%">{{ helper.trans('labels.crossBorderRateSource') }}</th>
              <th class="text-capitalize-first" style="width: 18%">{{ helper.trans('labels.crossBorderPayInRateSource') }}</th>
              <th class="text-capitalize-first" style="width: 11%">{{ helper.trans('labels.crossBorderAutomationGap') }}</th>
              <th class="text-capitalize-first" style="width: 11%">{{ helper.trans('labels.crossBorderOccupancyGap') }}</th>
              <th class="text-capitalize-first" style="width: 13%">{{ helper.trans('labels.crossBorderGapAmount') }}</th>
              <th class="text-capitalize-first" style="width: 13%">{{ helper.trans('labels.crossBorderStep') }}</th>
              <th style="width: 4%"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="rows.length === 0">
              <td colspan="8" class="text-center text-muted">{{ helper.trans('labels.crossBorderRatesEmpty') }}</td>
            </tr>
            <tr v-for="(row, index) in rows" :key="index">
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'currency')">
                  <Multiselect class="multiselect-sm"
                               :class="parentProps.class"
                               v-model="row.currency"
                               :options="currencyOptions(index)"
                               :custom-label="(opt) => `${opt}`"
                               select-label="Select"
                               deselect-label=""
                               placeholder=""
                               open-direction="bottom"
                               :multiple="false"
                               :searchable="true"
                               :internal-search="true"
                               :clear-on-select="false"
                               :close-on-select="true"
                               :options-limit="1000"
                               :limit="1000"
                               :show-no-results="false"
                               :hide-selected="false"
                  >
                  </Multiselect>
                </FormInputWrapper>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'source')">
                  <Multiselect class="multiselect-sm"
                               :class="parentProps.class"
                               v-model="row.source"
                               :options="rateSourceOptions(row.source)"
                               :custom-label="(opt) => rateSourceLabel(opt)"
                               select-label="Select"
                               deselect-label=""
                               placeholder=""
                               open-direction="bottom"
                               :multiple="false"
                               :searchable="true"
                               :internal-search="true"
                               :clear-on-select="false"
                               :close-on-select="true"
                               :options-limit="1000"
                               :limit="1000"
                               :show-no-results="false"
                               :hide-selected="false"
                  >
                  </Multiselect>
                </FormInputWrapper>
                <small class="text-muted">
                  {{ helper.trans('labels.crossBorderRateSourcePair', {currency: row.currency || helper.trans('labels.currency')}) }}
                </small>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'payInRateSource')">
                  <Multiselect class="multiselect-sm"
                               :class="parentProps.class"
                               v-model="row.payInRateSource"
                               :options="rateSourceOptions(row.payInRateSource)"
                               :custom-label="(opt) => rateSourceLabel(opt)"
                               select-label="Select"
                               deselect-label=""
                               placeholder=""
                               open-direction="bottom"
                               :multiple="false"
                               :searchable="true"
                               :internal-search="true"
                               :clear-on-select="false"
                               :close-on-select="true"
                               :options-limit="1000"
                               :limit="1000"
                               :show-no-results="false"
                               :hide-selected="false"
                  >
                  </Multiselect>
                </FormInputWrapper>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'automationGap')">
                  <input v-model="row.automationGap" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </FormInputWrapper>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'gap')">
                  <input v-model="row.gap" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </FormInputWrapper>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'gapAmount')">
                  <input v-model="row.gapAmount" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="999999.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                         :placeholder="helper.trans('labels.crossBorderAmountOffPlaceholder')"
                  >
                </FormInputWrapper>
              </td>
              <td>
                <FormInputWrapper v-slot="parentProps" :errors="errorsFor(index, 'step')">
                  <input v-model="row.step" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="999999.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                         :placeholder="helper.trans('labels.crossBorderAmountOffPlaceholder')"
                  >
                </FormInputWrapper>
              </td>
              <td class="text-end">
                <button type="button" @click.prevent="removeRow(index)" class="btn btn-sm btn-outline-danger">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <button type="button" @click.prevent="addRow()" class="btn btn-sm btn-outline-primary w-100 text-capitalize-first">
          {{ helper.trans('labels.crossBorderRatesAddCurrency') }}
        </button>

        <small class="d-block text-muted mt-3">{{ helper.trans('labels.crossBorderRatesDefaultHint') }}</small>
        <small class="d-block text-muted">{{ helper.trans('labels.crossBorderRatesGapFallbackHint') }}</small>
        <small class="d-block text-muted">{{ helper.trans('labels.crossBorderRatesAmountHint') }}</small>
      </div>
    </template>
    <template #footer>
      <div class="d-flex gap-2">
        <button v-if="storeId" type="button" @click.prevent="openHistory" class="btn btn-outline-secondary btn-sm text-capitalize-first">
          {{ helper.trans('labels.history') }}
        </button>
        <button type="button" @click="modal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">
          {{ helper.trans('button.cancel') }}
        </button>
      </div>
      <button type="button" @click="apply()" class="btn btn-outline-primary btn-sm text-capitalize-first">
        {{ helper.trans('button.apply') }}
      </button>
    </template>
  </b-modal>
  <SettingsHistoryModal ref="historyModal" entity-type="storeCrossBorder" />
</template>

<script lang="ts">
import {computed, defineComponent, reactive, ref, toRefs} from 'vue'
import {useStore} from "vuex";
import {BModal} from "bootstrap-vue-3";
import Multiselect from "vue-multiselect";
import {useNotification} from "@kyvg/vue3-notification";
import {helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import SettingsHistoryModal from "@/components/SettingsHistoryModal.vue";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {CrossBorderSettingRowFormDTO} from "@/models/form/MerchantStoreFormDTO";
import RateSourceDTO from "@/models/RateSourceDTO";

const notification = useNotification()

const emptyRow = (): CrossBorderSettingRowFormDTO => ({
  currency: null,
  source: null,
  payInRateSource: null,
  gap: null,
  automationGap: null,
  gapAmount: null,
  step: null,
})

const isBlank = (value: string|null) => value === null || value === undefined || value.trim() === ''

export default defineComponent({
  components: {
    BModal,
    Multiselect,
    FormInputWrapper,
    SettingsHistoryModal,
  },
  emits: ['apply'],
  setup(props, {emit}) {
    const store = useStore()
    const historyModal = ref<InstanceType<typeof SettingsHistoryModal> | null>(null)

    const state = reactive({
      modal: false,
      storeId: null as number | null,
      storeName: '',
      rows: [] as CrossBorderSettingRowFormDTO[],
      rowErrors: [] as ValidationErrorDTO[][],
      generalErrors: [] as ValidationErrorDTO[],
    })

    const withCustomSources = computed<RateSourceDTO[]>(() => store.getters['rateSources/withCustomSources'] ?? [])

    const rateSourceBySlug = (source: string): RateSourceDTO | null =>
      withCustomSources.value.find((item) => item.source === source) ?? null

    const rateSourceLabel = (source: string) => {
      const item = rateSourceBySlug(source)
      if (item === null) {
        return source
      }
      if (item.custom === true && item.fromCurrency && item.toCurrency) {
        return `${item.name} (${item.fromCurrency}-${item.toCurrency})`
      }
      return item.name ?? source
    }

    // курс, удалённый из списка, остаётся опцией своей строки — иначе он молча пропадёт при сохранении
    const rateSourceOptions = (current: string|null): string[] => {
      const options = withCustomSources.value.map((item) => item.source)
      return current && options.indexOf(current) === -1 ? [current, ...options] : options
    }

    const currencyOptions = (index: number): string[] => {
      const used = state.rows
        .filter((item, itemIndex) => itemIndex !== index && item.currency)
        .map((item) => item.currency)
      const options = ((store.getters['currencyMethods/crossBorderCurrencies'] ?? []) as string[])
        .filter((currency: string) => used.indexOf(currency) === -1)
      const current = state.rows[index]?.currency
      return current && options.indexOf(current) === -1 ? [current, ...options] : options
    }

    const errorsFor = (index: number, field: string): ValidationErrorDTO[] =>
      (state.rowErrors[index] ?? []).filter((error) => error.field === field)

    const addRowError = (index: number, field: string, message: string) => {
      if (!state.rowErrors[index]) {
        state.rowErrors[index] = []
      }
      state.rowErrors[index].push({code: 'INVALID_VALUE', field, message})
    }

    // ошибки бэка: crossBorderSettings | crossBorderSettings.TJS | crossBorderSettings.TJS.gap
    const setErrors = (errors: ValidationErrorDTO[]) => {
      state.rowErrors = state.rows.map(() => [] as ValidationErrorDTO[])
      state.generalErrors = []

      for (const error of errors) {
        const [, currency, field] = (error.field ?? '').split('.')
        if (!currency) {
          state.generalErrors.push(error)
          continue
        }

        const index = state.rows.findIndex(
          (row) => (row.currency ?? '').toUpperCase() === currency.toUpperCase()
        )
        if (index === -1) {
          state.generalErrors.push(error)
          continue
        }

        state.rowErrors[index].push({...error, field: field ?? 'currency'})
      }
    }

    const show = (
      rows: CrossBorderSettingRowFormDTO[],
      errors: ValidationErrorDTO[] = [],
      storeId: number|null = null,
      storeName = '',
    ) => {
      state.rows = (rows ?? []).map((row) => ({...emptyRow(), ...row}))
      state.storeId = storeId
      state.storeName = storeName
      setErrors(errors ?? [])
      state.modal = true

      store.dispatch('rateSources/loadWithCustomList')
    }

    const openHistory = () => {
      if (!state.storeId) {
        return
      }

      historyModal.value?.show(
        state.storeId,
        helper.trans('labels.cross_border_settings_history') + `: ${state.storeName}`,
      )
    }

    const addRow = () => {
      state.rows.push(emptyRow())
      state.rowErrors.push([])
    }

    const removeRow = (index: number) => {
      state.rows.splice(index, 1)
      state.rowErrors.splice(index, 1)
    }

    const isRowEmpty = (row: CrossBorderSettingRowFormDTO) =>
      isBlank(row.currency) && isBlank(row.source) && isBlank(row.payInRateSource)
      && isBlank(row.gap) && isBlank(row.automationGap)
      && isBlank(row.gapAmount) && isBlank(row.step)

    // gap: 0 < x < 100; automationGap: 0 <= x < 100 (0 выключает коридор автозакрытия)
    // gapAmount/step: >= 0 (пусто или 0 выключает фикс-режим)
    const validate = (rows: CrossBorderSettingRowFormDTO[]): boolean => {
      state.rowErrors = rows.map(() => [] as ValidationErrorDTO[])
      state.generalErrors = []
      const seen = [] as string[]

      rows.forEach((row, index) => {
        if (isBlank(row.currency)) {
          addRowError(index, 'currency', helper.trans('store.cross_border.currency_required'))
        } else if (seen.indexOf(row.currency!) !== -1) {
          addRowError(index, 'currency', helper.trans('store.cross_border.duplicate_currency'))
        } else {
          seen.push(row.currency!)
        }

        for (const field of ['gap', 'automationGap'] as const) {
          const value = row[field]
          if (isBlank(value)) {
            continue
          }
          const parsed = Number((value as string).replace(',', '.'))
          const allowZero = field === 'automationGap'
          const outOfRange = allowZero
            ? parsed < 0 || parsed >= 100
            : parsed <= 0 || parsed >= 100
          if (!Number.isFinite(parsed) || outOfRange) {
            addRowError(
              index,
              field,
              helper.trans(allowZero ? 'store.cross_border.invalid_automation_percent' : 'store.cross_border.invalid_percent'),
            )
          }
        }

        for (const field of ['gapAmount', 'step'] as const) {
          const value = row[field]
          if (isBlank(value)) {
            continue
          }
          const parsed = Number((value as string).replace(',', '.'))
          if (!Number.isFinite(parsed) || parsed < 0) {
            addRowError(index, field, helper.trans('store.cross_border.invalid_amount'))
          }
        }
      })

      const hasErrors = state.rowErrors.some((errors) => errors.length > 0)
      if (hasErrors) {
        notification.notify({
          type: 'error',
          title: helper.trans('labels.error'),
          text: helper.trans('store.cross_border.validation_failed'),
        })
      }

      return !hasErrors
    }

    const apply = () => {
      // пустые строки просто выбрасываем, иначе индексы строк и ошибок разъедутся
      state.rows = state.rows.filter((row) => !isRowEmpty(row))

      if (!validate(state.rows)) {
        return
      }

      emit('apply', state.rows.map((row) => ({
        currency: row.currency,
        source: isBlank(row.source) ? null : row.source,
        payInRateSource: isBlank(row.payInRateSource) ? null : row.payInRateSource,
        gap: isBlank(row.gap) ? null : (row.gap as string).replace(',', '.'),
        automationGap: isBlank(row.automationGap) ? null : (row.automationGap as string).replace(',', '.'),
        gapAmount: isBlank(row.gapAmount) ? null : (row.gapAmount as string).replace(',', '.'),
        step: isBlank(row.step) ? null : (row.step as string).replace(',', '.'),
      } as CrossBorderSettingRowFormDTO)))

      state.modal = false
    }

    return {
      ...toRefs(state),
      helper,
      historyModal,
      show,
      openHistory,
      apply,
      addRow,
      removeRow,
      errorsFor,
      currencyOptions,
      rateSourceOptions,
      rateSourceLabel,
    }
  }
})
</script>
